import { CmsProtectionDetailsHeader } from '../../models/protection-details/cms-protection-details-header.interface';

export const mockCmsProtectionDetailsHeader: CmsProtectionDetailsHeader = {
  protectionDetailsHeaderSubtitle: 'protectionDetailsHeaderSubtitle',
  protectionDetailsHeaderTitle: 'protectionDetailsHeaderTitle',
};
